import {
  ButtonBase,
  IconButton,
  ListItem,
  Menu,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { ProformaStatus } from '../../types/walletEnums'
import { ProformaBrief } from '../../types/walletProforma'
import StatusBox from './ProformaStatusBox'
import useStyles from './styles/ProformasTable.styles'

interface ProformaRowProps {
  data: ProformaBrief
}

const ProformaRow: React.FC<ProformaRowProps> = ({ data }) => {
  const classes = useStyles()
  const params = useParams<{ walletId: string }>()

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)
  const handleClickMoreOptions = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <ButtonBase
        data-cy="findNewProforma"
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/adopay/wallet/${params.walletId}/invoice-list/${data.proformaID}/details`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.proformaNumber}</Typography>
        </div>
        <div>
          <Typography variant="body1">{data.createdAt}</Typography>
        </div>
        <div>
          <Typography variant="body1">{data.updatedAt}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {data.status == 'pendingConfirmation' ||
            data.status == 'cancelled' ||
            data.status == 'rejected'
              ? getTranslate('Proforma')
              : getTranslate('Invoice')}
          </Typography>
        </div>
        <div>
          <StatusBox status={data.status as ProformaStatus} />
        </div>
      </ButtonBase>
      <div className={classes.rowMenu}>
        <IconButton onClick={handleClickMoreOptions}>
          <MoreIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <ListItem
            // disabled={!hasAccessToViewRoomType}
            button
            component={LocalizedLink}
            to={`/`}>
            {getTranslate('View Room Types')}
          </ListItem>
          <ListItem
            // disabled={!hasAccessToViewRatePlan}
            button
            component={LocalizedLink}
            to={'/'}>
            {getTranslate('View Rate Plans')}
          </ListItem>
          <ListItem button onClick={() => {}}>
            {getTranslate('Import Data')}
          </ListItem>
        </Menu>
      </div>
    </div>
  )
}

export default ProformaRow
